export function isElectronRuntime(userAgent = navigator.userAgent): boolean {
  return userAgent.includes("Electron/");
}
